/**
 * Smarttech URLS
 */
export const NOTE_BOOK_TRIAL = 'https://education.smarttech.com/products/notebook/download#trial'
export const SMART_EXCHANGE_TERMS = 'https://home.smarttech.com/legal/legal-notice#smart-exchange'
export const FEEDBACK_LINK = 'https://smarttech.uservoice.com/forums/915598-smart-exchange-beta'
export const RESOURCE_GUIDE = 'https://support.smarttech.com/docs/redirect/?product=exchange&context=how-we-moderate'
export const SIGN_IN_SIGNUP_GUIDE = 'https://support.smarttech.com/docs/software/exchange/en/sign-up-and-sign-in/default.cshtml'
export const RESOURCE_SUBMISSION_TERMS = ' https://home.smarttech.com/legal/legal-notice#submission'
export const PRIVACY_POLICY = 'https://home.smarttech.com/legal/privacy-policy'
export const UPLOAD_LEGAL_TERMS = 'https://home.smarttech.com/legal/legal-notice#submission'
export const LEGAL_COMMONS = 'https://creativecommons.org/licenses/by/4.0/'
export const RESOURCE_CREATION_GUIDE = 'https://support.smarttech.com/docs/redirect/?product=exchange&context=create-resources'
export const ID_ACCOUNT = 'https://myaccount.smarttech.com/'
export const LEGACY_EXCHANGE_DOMAIN = 'https://Legacyexchange.smarttech.com'
export const SMEX_LEARN_MORE_VIDEO = 'http://smarttech.com/discoverexchange'
export const SMEX_LEARN_MORE_VIDEO_GERMAN = 'https://youtube.com/watch?v=AoceqC8Ajwo'
export const SMEX_LEARN_MORE_VIDEO_SWEDISH = 'https://www.youtube.com/watch?v=p_2QsesrGvc'
export const SMART_EXCHANGE = 'https://exchange.smarttech.com'
export const EXCHANGE_SMARTTECH_PROD = 'https://exchange.smarttech-prod.com'
export const SMARTTECH = 'https://smarttech.com'
export const LEGACY_SMEX_SEARCH = 'http://legacyexchange.smarttech.com/search.html?q='
export const ACTIVITY_INFO_DEMO = 'https://www.youtube.com/watch?v=PlsTdj7BVFA'
export const YOUTUBE_API = 'https://i.ytimg.com/vi/'
export const SMART_EXEMPLARY_EDUCATOR = 'https://legacy.smarttech.com/en/education/smart-community-programs/smart-ambassadors'
export const SUPPORT = 'https://support.smarttech.com/docs/redirect/?product=exchange'
export const TWEET = 'https://twitter.com/intent/tweet?text='
export const PINTEREST = 'http://pinterest.com/pin/create/button/?'
export const FB_SHARE = 'https://www.facebook.com/sharer/sharer.php?u='
export const SMEX_CAROUSEL_LUMIO = 'http://go.smarttech.com/smex-carousel-lumio'
export const SMEX_CAROUSEL_LESSONS_IN_IQ = 'http://go.smarttech.com/smex-carousel-lessons-in-iQ'
